// src/belediye/components/notifications/notificationMeta.js
//
// Bildirim sunum sözlüğü — TEK KAYNAK. Seviye (level) ve kaynak (source_module)
// için Türkçe etiketler; duyuru gönderim kategorileri. Toast, zil, "Tümü" sayfası
// ve duyuru formu buradan besleniyor → tutarlı dil.

// Seviye → Türkçe etiket (mantıklı, sade kategoriler)
export const LEVEL_LABELS = {
  info: "Bilgi",
  success: "Olumlu",
  warning: "Uyarı",
  critical: "Acil",
};

export const levelLabel = (lvl) => LEVEL_LABELS[String(lvl || "info")] || "Bilgi";

// Duyuru gönderirken seçilebilen kategoriler (sade: Bilgi / Uyarı / Acil)
export const DUYURU_LEVELS = [
  { key: "info", label: "Bilgi" },
  { key: "warning", label: "Uyarı" },
  { key: "critical", label: "Acil" },
];

// Kaynak modül → Türkçe etiket
export const SOURCE_LABELS = {
  // FAZ-106 — yeni başvuru bildirimi (core_app).
  basvuru: "Başvuru",
  close_approval: "Kapatma Onayı",
  gorev: "Talepler",
  mesajlasma: "Mesajlar",
  duyuru: "Duyuru",
  sistem: "Sistem",
  sms: "SMS",
};

export const sourceLabel = (src) => SOURCE_LABELS[String(src || "")] || "Bildirim";

// FAZ-51 — Bildirim merkezi SEGMENTLERİ.
// Kullanıcı kararı: her şey tek sayfada olacak ama karışmayacak. Segment =
// kaynak kümesi; "Tümü" hepsini kapsar. Yeni bir kaynak eklenirse BURAYA da
// eklenir, yoksa yalnız "Tümü"nde görünür.
// FAZ-77: "Duyuru & Sistem" → "Duyurular". `sistem` kaynağı kayıtlı ama hiçbir
// üretici yok (bkz. bildirim_app/sources.py: register_core_sources) — sekmede
// "Sistem" yazması, hiç dolmayacak bir bölme sözü veriyordu. Kaynak altyapıda
// duruyor ve bu sekmeye düşüyor; dolduğu gün etiket kendiliğinden doğru olur.
export const SEGMENTS = [
  { key: "all", label: "Tümü", sources: null },
  { key: "mesajlasma", label: "Mesajlar", sources: ["mesajlasma"] },
  { key: "gorev", label: "Talepler", sources: ["gorev"] },
  // FAZ-106: "Başvurular" sekmesi artık İKİ kaynak taşıyor — başvurunun
  // kendisi (basvuru) ve o başvuru üzerindeki kapatma kararları
  // (close_approval). Sekme başvuruyu konu alan her şeyin adresi.
  { key: "basvuru", label: "Başvurular", sources: ["basvuru", "close_approval"] },
  { key: "duyuru", label: "Duyurular", sources: ["duyuru", "sistem", "sms"] },
];

/** Bildirim bu segmente düşüyor mu? ("all" her şeyi alır) */
export const matchesSegment = (n, segmentKey) => {
  const seg = SEGMENTS.find((s) => s.key === segmentKey);
  if (!seg || !seg.sources) return true;
  return seg.sources.includes(String(n?.source_module || "").trim());
};

/** Sunucuya gidecek `source` parametresi ("all" → undefined = süzme yok). */
export const segmentSourceParam = (segmentKey) => {
  const seg = SEGMENTS.find((s) => s.key === segmentKey);
  if (!seg || !seg.sources) return undefined;
  return seg.sources.join(",");
};

/**
 * Segment rozeti — kaynak başına okunmamış sayılarından (backend) toplar.
 * @param {object} unreadBySource  {"gorev": 4, "duyuru": 1, ...}
 * @param {object} toplam          "Tümü" için backend'in tek unread_count'u
 */
export const segmentUnreadFromSources = (unreadBySource, toplam = 0) => {
  const kaynaklar = unreadBySource && typeof unreadBySource === "object" ? unreadBySource : {};
  const out = {};
  for (const s of SEGMENTS) {
    if (!s.sources) {
      out[s.key] = Number(toplam) || 0;
      continue;
    }
    out[s.key] = s.sources.reduce((acc, k) => acc + (Number(kaynaklar[k]) || 0), 0);
  }
  return out;
};

// Olay kodu → Türkçe etiket. "Tümü" sayfasındaki kategori süzgeci BURADAN
// türetilir (FAZ-47): eskiden süzgeçte 3 kapatma-talebi + duyuru elle yazılıydı,
// 13 görev olayının HİÇBİRİ listede yoktu. Yeni olay eklenince tek yer değişir.
export const EVENT_LABELS = {
  // FAZ-106 — vatandaştan yeni başvuru düştü.
  "basvuru.yeni": "Başvuru • Yeni",
  "close_request.created": "Kapatma Talebi • Yeni",
  "close_request.approved": "Kapatma Talebi • Onay",
  "close_request.rejected": "Kapatma Talebi • Red",
  "close_request.cancelled": "Kapatma Talebi • İptal",
  "duyuru.genel": "Duyuru",
  "task.assigned": "Talep • Size atandı",
  "task.assigned_unit": "Talep • Birim havuzu",
  "task.accepted": "Talep • Üstlenildi",
  "task.started": "Talep • Başlandı",
  "task.status_changed": "Talep • Geri bildirim bekliyor",
  "task.commented": "Talep • Yorum",
  "task.ask_status": "Talep • Durum soruldu",
  "task.completion_requested": "Talep • Onay bekliyor",
  "task.changes_requested": "Talep • Düzeltme istendi",
  "task.completed": "Talep • Tamamlandı",
  "task.cancelled": "Talep • İptal",
  "task.reopened": "Talep • Yeniden açıldı",
  "task.due_soon": "Talep • Süre yaklaşıyor",
  "task.overdue": "Talep • Süre doldu",
  // FAZ-51 — mesajlaşma köprüsü (sohbet başına TEK açık satır)
  "mesaj.yeni": "Mesaj • Yeni",
};

/** Süzgeç seçenekleri (sıra: sözlük sırası). */
export const EVENT_FILTER_OPTIONS = Object.entries(EVENT_LABELS).map(
  ([value, label]) => ({ value, label })
);

// FAZ-77 — OLAY → SEGMENT eşlemesi.
//
// Kusur: kategori süzgeci 20 olayın TAMAMINI düz liste olarak sunuyordu. Açık
// sekme "Görevler" iken listede "Kapatma Talebi • Onay" seçilebiliyordu ve
// sonuç garanti boş ekrandı (iki süzgeç birbirini imkânsız kılıyor). Süzgeç
// artık yalnız AÇIK SEKMEDE mümkün olan olayları gösterir.
const EVENT_SEGMENT = {
  "basvuru.": "basvuru",
  "close_request.": "basvuru",
  "duyuru.": "duyuru",
  "task.": "gorev",
  "mesaj.": "mesajlasma",
};

export const eventSegment = (ev) => {
  const kod = String(ev || "");
  for (const [onek, seg] of Object.entries(EVENT_SEGMENT)) {
    if (kod.startsWith(onek)) return seg;
  }
  return "";
};

/** Açık segmentte anlamlı olan kategori seçenekleri ("all" → hepsi). */
export const eventOptionsForSegment = (segmentKey) => {
  if (!segmentKey || segmentKey === "all") return EVENT_FILTER_OPTIONS;
  return EVENT_FILTER_OPTIONS.filter((o) => eventSegment(o.value) === segmentKey);
};

export const eventLabel = (ev) => EVENT_LABELS[String(ev || "")] || String(ev || "");

// FAZ-69 — GÖSTERİLECEK GÖVDE (tek kaynak; toast + zil + sayfa aynı kural).
//
// İki kusuru birden kapatır:
//   1) `bildirimApi.normalizeItem` gövde boşken `message`i BAŞLIKLA dolduruyor
//      → satırda aynı cümle iki kez yazılıyordu ("Talebiniz onaylandı" /
//      "Talebiniz onaylandı").
//   2) Gövde gerçekten boşsa yüzeyler "—" çiziyordu; boş satır çizmemek daha
//      dürüst.
// Kural: gövde başlıktan FARKLIYSA yazılır, değilse hiç yazılmaz.
const govdeAdayi = (n) =>
  String(n?.body ?? "").trim() ||
  String(n?.message ?? "").trim() ||
  String(n?.inapp_payload?.message ?? "").trim() ||
  String(n?.payload?.message ?? "").trim();

export const bildirimGovdesi = (n) => {
  const govde = govdeAdayi(n);
  const baslik = String(n?.title ?? "").trim();
  return govde && govde !== baslik ? govde : "";
};

// ── FAZ-85 — "KİMİN NE YAPTIĞI" + "HANGİ TALEP" ───────────────────────────
//
// Kullanıcı (2026-08-01): "bildirimlerde biraz daha detay olabilir; kimin ne
// yaptığı ve ilgili biçimde talebin adı vb. bir şeyler olabilir."
//
// Veri ZATEN vardı, sunum yoktu: gövde tek bir dizeydi —
//   "#110 · Kaldırım onarımı — beton döküldü, yarın bitiyor"
// tek satırda, tek renkte, ellipsis'le kırpılarak çiziliyordu. "Hangi talep"
// ile "ne yazıldı" görsel olarak ayrışmıyordu; uzun başlıklı bir talepte not
// hiç görünmüyordu bile.
//
// Üreticiler KAYIT KİMLİĞİNİ payload'da ayrıca gönderiyor (payload.kayit).
// SERBEST METİN (yorum, karar gerekçesi, mesaj önizlemesi) payload'a
// KOPYALANMAZ — payload aynı zamanda SMS şablon bağlamıdır (operatör loglarına
// düşer) ve silinen mesajın önizlemesi yalnız `body` boşaltılarak temizleniyor;
// ikinci bir kopya o temizlikten kaçardı. İkisinin de testi var.
//
// Buna gerek de yok: gövde her zaman kayıt kimliğiyle BAŞLAR, kalanı nottur.
// Bu bir tahmin değil, ürettiğimiz biçimin tersidir.
//
// ESKİ KAYITLAR: DB'de payload'ı olmayan binlerce satır var. Onlar için gövde
// ayraçtan bölünür — ama YALNIZ kayıt kimliği ÜRETEN kaynaklarda. Mesajda gövde
// bir önizlemedir; ayraç aramak mesajın metnini kayıt adı yerine koyardı.
// FAZ-106: `basvuru` da kayıt kimliği üretir (takip no · konu) ve payload'da
// `kayit` alanını AYRICA gönderir; buradaki liste yalnız payload'sız/eski
// satırlar için gövdeyi ayraçtan bölme iznidir.
const KAYIT_URETEN_KAYNAKLAR = new Set(["gorev", "close_approval", "basvuru"]);
const AYRAC = " — ";

const kaynakKayitUretir = (n) =>
  KAYIT_URETEN_KAYNAKLAR.has(String(n?.source_module || ""));

/** Ham kayıt kimliği — başlık-tekrarı süzgeci UYGULANMADAN.
 *  Not hesabı bunu kullanır: kayıt satırı ekranda gizlense bile gövdedeki
 *  sınır aynı yerdedir. */
const kayitHam = (n) => {
  const acik = String(n?.payload?.kayit ?? n?.inapp_payload?.kayit ?? "").trim();
  if (acik) return acik;
  if (!kaynakKayitUretir(n)) return "";
  const govde = bildirimGovdesi(n);
  if (!govde) return "";
  const i = govde.indexOf(AYRAC);
  return (i > 0 ? govde.slice(0, i) : govde).trim();
};

/**
 * HANGİ KAYIT — "#110 · Kaldırım onarımı" / "BSV-2026-14 · Çöp konteyneri".
 * Başlık zaten bu metni içeriyorsa BOŞ döner: aynı bilgi iki satırda yazılmaz
 * (mesaj bildiriminin başlığı "Sohbet adı · Gönderen" biçimindedir).
 */
export const kayitEtiketi = (n) => {
  const etiket = kayitHam(n);
  if (!etiket) return "";
  const baslik = String(n?.title ?? "").trim();
  return baslik && baslik.includes(etiket) ? "" : etiket;
};

/** NE YAZILDI — yorum metni, teslim/karar notu, mesaj önizlemesi. */
export const bildirimNotu = (n) => {
  const govde = bildirimGovdesi(n);
  if (!govde) return "";
  const kayit = kayitHam(n);
  if (kayit && govde.startsWith(kayit)) {
    return govde.slice(kayit.length).replace(/^\s*—\s*/, "").trim();
  }
  // Kayıt gövdenin başında değil: kayıt üreten kaynakta ayraçtan böl, diğerinde
  // (mesaj, duyuru) gövdenin TAMAMI nottur.
  if (!kaynakKayitUretir(n)) return govde;
  const i = govde.indexOf(AYRAC);
  return i > 0 ? govde.slice(i + AYRAC.length).trim() : "";
};

// Bildirimi tetikleyen/gönderen kişinin görünen adı (adı soyadı) — actor.full_name
// yoksa username; hiçbiri yoksa boş.
export const actorName = (n) => {
  const a = n?.actor;
  if (!a) return "";
  const full = String(a.full_name || "").trim();
  if (full) return full;
  return String(a.username || "").trim();
};
